export default {
  init: function() {
    if(!this.component) {
      return
    }

    this.addEventListenners()
  },

  addEventListenners: function() {
    this.component.forEach(function(component) {
      component.addEventListener('click', this.handleSlideToggle)
    }.bind(this))
  },

  handleSlideToggle: function(e) {
    e.preventDefault()

    this.classList.toggle('is-toggled')

    jQuery(this.getAttribute('data-target')).slideToggle()
  },

  component: document.querySelectorAll('[data-component="slide-toggle"]')
}
